import * as types from "./actionTypes";
import { initialState, childState } from "./initialState";
import { cloneDeep } from "../../utils/utils";
import { API_V1_AUDIO_FILE_REVIEW_SUCCESS } from "./actionTypes";

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.AUDIO_LOADING:
      return setLoading(state, action.payload);
    case types.SET_AUDIO_FILE_FETCH_DATA:
      return setFetchData(state, true);
    case types.API_V1_GET_AUDIO_FILE_INFO_SUCCESS:
      return setAudioFileInfo(state, action.payload);
    case types.API_V1_GET_AUDIO_FILE_INFO_FAILURE:
      return initialState;
    case types.API_V1_AUDIO_FILE_REVIEW_SUCCESS:
      return removeAudioFile(state, action.payload);
    default:
      return state;
  }
};

const removeAudioFile = (state, { accountId, index }) => {
  const clonedState = cloneDeep(state);
  delete clonedState[accountId].status.readyForReview.audio.splice(index, 1);
  return clonedState;
};

const setAudioFileInfo = (state, payload) => {
  delete state[0]; // Delete initial child state
  const clonedState = cloneDeep(state);
  clonedState.fetchData = false;

  const {
    total_ready_for_recording,
    total_ready_for_review,
    metadata_created_this_year,
    accounts,
  } = payload;
  clonedState.totalReadyForRecording = total_ready_for_recording;
  clonedState.totalReadyForReview = total_ready_for_review;
  clonedState.metadataCreatedThisYear = metadata_created_this_year;

  accounts.forEach((account) => {
    const { id, total, status } = account;
    if (!(id in clonedState)) {
      clonedState[id] = cloneDeep(childState); // Initialize as child state
      clonedState[id].id = id;
    }
    clonedState[id].total = total;
    clonedState[id].status = {
      readyForReview: {
        total: status.ready_for_review.total,
        audio: status.ready_for_review.audio,
      },
      readyForRecording: {
        total: status.ready_for_recording.total,
      },
    };
  });
  return clonedState;
};

const setLoading = (state, loading) => {
  return { ...state, loading };
};

const setFetchData = (state, v) => {
  const clonedState = cloneDeep(state);
  clonedState.fetchData = v;
  return clonedState;
};

export default reducer;
